function phoneInput() {
	const lpForm = document.querySelector("[data-jsmodule='lpForm']");
	if (lpForm) {
		let phoneInput = lpForm.querySelector(".form input[type='tel']");
		const submitButton = lpForm.querySelector(".form .button");
		const buttonColor = window
			.getComputedStyle(submitButton)
			.getPropertyValue("background-color");
		if (phoneInput) {
			phoneInput.style.borderColor = buttonColor;

			phoneInput.addEventListener("blur", function (e) {
				if (
					phoneInput.classList.contains("filled") &&
					phoneInput.value.length === 9
				) {
					let phoneNumber = e.target.value;
					phoneNumber =
						phoneNumber.substr(0, 3) +
						" " +
						phoneNumber.substr(3, 3) +
						" " +
						phoneNumber.substr(6, 3);
					phoneInput.value = phoneNumber;
				}
			});
		}
	}
}

export default phoneInput;
